import React, { useState, useEffect } from 'react';
import { Button } from "../ui/button"; // 
import { Input } from "../ui/input"; // 
import { Label } from "../ui/label"; // 
import { CalendarIcon } from 'lucide-react'; // 
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'; // 
import { Calendar } from '../ui/calendar'; // 
import { format } from 'date-fns';
import { cn } from '../../lib/utils'; // 

// --- NEW Reusable DateTimePicker Component ---
export const DateTimePicker = ({ label, date, setDate, disabled = false }) => {
  const [time, setTime] = useState({
    hour: date ? String(date.getHours()).padStart(2, '0') : '00',
    minute: date ? String(date.getMinutes()).padStart(2, '0') : '00',
  });

  useEffect(() => {
    // Update time inputs when the main date object changes (e.g., on load)
    if (date) {
      setTime({
        hour: String(date.getHours()).padStart(2, '0'),
        minute: String(date.getMinutes()).padStart(2, '0'),
      });
    }
  }, [date]);

  const handleDateSelect = (selectedDate) => {
    if (!selectedDate) {
      setDate(null);
      return;
    }
    const newDate = new Date(selectedDate);
    // Preserve the existing time when the date changes
    newDate.setHours(parseInt(time.hour, 10));
    newDate.setMinutes(parseInt(time.minute, 10));
    setDate(newDate);
  };

  const handleTimeChange = (e) => {
    const { name, value } = e.target;
    setTime(prev => ({ ...prev, [name]: value }));
  };

  const handleTimeSet = () => {
    // When time inputs lose focus, update the main date object
    if (date) {
      const newDate = new Date(date);
      let hour = parseInt(time.hour, 10);
      let minute = parseInt(time.minute, 10);
      
      // Basic validation
      if (isNaN(hour) || hour < 0 || hour > 23) hour = 0;
      if (isNaN(minute) || minute < 0 || minute > 59) minute = 0;

      newDate.setHours(hour);
      newDate.setMinutes(minute);
      setDate(newDate);
    }
  };

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex items-center space-x-2">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant={"outline"} // [cite: 12]
              disabled={disabled}
              className={cn("w-[280px] justify-start text-left font-normal", !date && "text-muted-foreground")}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {date ? format(date, "PPP") : <span>Pick a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0">
            <Calendar
              mode="single"
              selected={date}
              onSelect={handleDateSelect}
              initialFocus
              disabled={disabled}
            />
          </PopoverContent>
        </Popover>
        <Input
          name="hour"
          type="number"
          min="0"
          max="23"
          value={time.hour}
          onChange={handleTimeChange}
          onBlur={handleTimeSet}
          className="w-20"
          placeholder="HH"
          disabled={disabled}
        />
        <span>:</span>
        <Input
          name="minute"
          type="number"
          min="0"
          max="59"
          value={time.minute}
          onChange={handleTimeChange}
          onBlur={handleTimeSet}
          className="w-20"
          placeholder="MM"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

